export class CalculationLocationCommand {
    public locationNumber: string;

    public constructor(init: Partial<CalculationLocationCommand>) {
        Object.assign(this, init);
    }
}
